// ── A STATIKUSAN prerenderelt útvonalak – EGYETLEN forrás ────────────────────
//
// A scripts/prerender.js ebből renderel, a frontend pedig ebből tudja, mely
// belső linkek kaphatnak záró perjelt (utils/url.js → withSlash). Korábban a
// lista csak a prerender szkriptben élt, így a kód nem tudhatta, hogy egy
// útvonal kész HTML-ként létezik-e (audit #6: perjel nélküli linkek 301-gyel
// értek célba). Az összehasonlító és a termékoldalak dinamikusan jönnek hozzá
// (compareEngine, készlet-API) – azok nincsenek itt.
//
// Új statikus oldal = egy sor ide (különben nem prerenderelődik, és a linkje
// perjel nélkül marad).

export const PRERENDER_UTVONALAK = [
  '/',
  '/szerviz',
  '/hidrogel',
  '/telefonok',
  '/felvasarlas',
  '/uzletek',
  '/vip-klub',
  '/vip-jatekszabalyzat',
  '/blog',
  '/gyakori-kerdesek',
  '/miert-norbiphone',
  '/ertekeles',
  '/iphone-kijelzocsere-oroshaza',
  '/iphone-hatlapcsere',
  '/iphone-akkumulatorcsere-oroshaza',
  '/samsung-kijelzocsere-oroshaza',
  '/samsung-xiaomi-akkumulatorcsere',
  '/adatkezeles',
  '/cookie',
  '/aszf',
  '/impresszum',
  '/akadalymentesseg',
  '/eszkozteszt',
  '/bejelentes',
  '/telefonvadasz',
  // noindex (nem is kerül a sitemapba), de a /bejelentes űrlapja LINKEL rá:
  // ha nincs prerenderelve, a build-validátor törött belső linknek látja, és
  // a látogató is csupasz SPA-shellt kapna az adatkezelési tájékoztató helyett.
  '/bejelentes-adatkezeles',

  // ── Márkaoldalak (docs/seo-terv-markak.md) ───────────────────────────────
  // ÖNÁLLÓ SEO-landingek, nem aliasok. Prerender KELL: a query-paraméteres
  // nézetet nem lehet kisütni, ezért kap mindegyik tiszta útvonalat.
  '/hasznalt-iphone-oroshaza',
  '/hasznalt-samsung-telefon-oroshaza',
  '/hasznalt-xiaomi-telefon-oroshaza',
  '/hasznalt-honor-telefon-oroshaza',
  '/hasznalt-huawei-telefon-oroshaza',
  '/iphone-szerviz-oroshaza',
  '/samsung-szerviz-oroshaza',
  '/android-szerviz-oroshaza',
  '/iphone-felvasarlas-oroshaza',
  '/samsung-felvasarlas-oroshaza',

  // (Sprint 2C: a márka-szerviz/-felvásárlás oldalak fent már szerepelnek –
  // itt korábban duplán álltak, és kétszer renderelődtek. Audit #7.)
  // Blog-cikkek – fix, indexelt oldalak.
  '/blog/hasznalt-iphone-vasarlas-2026',
  '/blog/uvegfolia-vs-hidrogel-folia',
  '/blog/iphone-kijelzocsere-ar',
  '/blog/mikor-kell-akkumulatort-cseralni',
  '/blog/hasznalt-iphone-vasarlas-tippek',
  '/blog/puposodo-akkumulator',
  '/blog/megeri-megjavitani-a-telefont',
  '/blog/iphone-18-pro-mit-tud',
  '/blog/iphone-duo-osszecsukhato-iphone',
];
